// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-link[data-v-ba04e740]{align-items:center;color:#3b3b3b;display:flex;margin-top:15px}.file-link .icon[data-v-ba04e740]{margin-right:20px;transition:color .2s ease}.file-link .file-info[data-v-ba04e740]{color:#5e6163;font-size:14px;margin-left:20px}.file-link:hover .icon[data-v-ba04e740]{color:#d12326}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
